// extracted by mini-css-extract-plugin
module.exports =  {"container":"container__zzOUT","title":"title__MF4kP","description":"description__QD0LG"};